// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes Item-module__pop___DsGbx {
  0% {
    transform: scale(1);
    box-shadow: var(--box-shadow);
  }
  100% {
    transform: scale(var(--scale));
    box-shadow: var(--box-shadow-picked-up);
  }
}

@keyframes Item-module__fadeIn___NR8Qu {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.Item-module__Wrapper___LKtob {
  display: flex;
  box-sizing: border-box;
  transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)
    scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1));
  transform-origin: 0 0;
  touch-action: manipulation;
}

.Item-module__Wrapper___LKtob.Item-module__fadeIn___NR8Qu {
    animation: Item-module__fadeIn___NR8Qu 500ms ease;
  }

.Item-module__Wrapper___LKtob.Item-module__dragOverlay___feLrU {
    --scale: 1.05;
    --box-shadow: 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);
    --box-shadow-picked-up: 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05),
      -1px 0 15px 0 rgba(34, 33, 81, 0.01),
      0px 15px 15px 0 rgba(34, 33, 81, 0.25);
    z-index: 999;
  }

.Item-module__Item___FoLxg {
  position: relative;
  display: flex;
  flex-grow: 1;
  /* box-shadow: \$box-shadow; */
  background-color: var(--card-bg-color);
  -webkit-tap-highlight-color: transparent;

  /* white-space: nowrap; */

  transform: scale(var(--scale, 1));
  transition: box-shadow 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);
}

.Item-module__Item___FoLxg:focus-visible {
    box-shadow: 0 0px 4px 1px #4c9ffe, 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);
  }

.Item-module__Item___FoLxg:not(.Item-module__withHandle____pAIQ) {
    touch-action: manipulation;
    cursor: grab;
  }

.Item-module__Item___FoLxg.Item-module__dragging___QLpIK:not(.Item-module__dragOverlay___feLrU) {
    opacity: var(--dragging-opacity, 0.5);
    z-index: 0;
  }

.Item-module__Item___FoLxg.Item-module__dragging___QLpIK:not(.Item-module__dragOverlay___feLrU):focus {
      box-shadow: 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);
    }

.Item-module__Item___FoLxg.Item-module__disabled___DSRgF {
    color: #999;
    background-color: #f1f1f1;
  }

.Item-module__Item___FoLxg.Item-module__disabled___DSRgF:focus {
      box-shadow: 0 0px 4px 1px rgba(0, 0, 0, 0.1), 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05), 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);
    }

.Item-module__Item___FoLxg.Item-module__disabled___DSRgF {
    cursor: not-allowed;
}

.Item-module__Item___FoLxg.Item-module__dragOverlay___feLrU {
    cursor: inherit;
    /* box-shadow: 0 0px 6px 2px \$focused-outline-color; */
    animation: Item-module__pop___DsGbx 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);
    transform: scale(var(--scale));
    box-shadow: var(--box-shadow-picked-up);
    opacity: 1;
  }

.Item-module__Item___FoLxg.Item-module__color___HaFGG:before {
    content: '';
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    height: 100%;
    width: 3px;
    display: block;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background-color: var(--color);
  }

.Item-module__Item___FoLxg:hover .Item-module__Remove___fvxU9 {
      visibility: visible;
    }

.Item-module__Remove___fvxU9 {
  visibility: hidden;
}

.Item-module__Actions___YOB5O {
  display: flex;
  align-self: flex-start;
  margin-top: -12px;
  margin-left: auto;
  margin-bottom: -15px;
  margin-right: -10px;
}
`, "",{"version":3,"sources":["webpack://./resources/app/modules/common/SortableNew/Item.module.css","<no source>"],"names":[],"mappings":"AAUA;EACE;IACE,mBAAmB;IACnB,6BAA6B;EAC/B;EACA;IACE,8BAA8B;IAC9B,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB;uDACqD;EACrD,qBAAqB;EACrB,0BAA0B;AAc5B;;AAZE;IACE,iDAA4B;EAC9B;;AAEA;IACE,aAAa;IACb,sIAAyB;IACzB;;4CAEwC;IACxC,YAAY;EACd;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,sCAAmC;EACnC,wCAAwC;;EAExC,yBAAyB;;EAEzB,iCAAiC;EACjC,gEAAgE;AAyDlE;;AAvDE;IACE,2JAA6D;EAC/D;;AAEA;IACE,0BAA0B;IAC1B,YAAY;EACd;;AAEA;IACE,qCAAqC;IACrC,UAAU;EAKZ;;AAHE;MACE,oIAAuB;IACzB;;AAGF;IACE,WAAW;IACX,yBAAyB;EAK3B;;AAJE;MACE,sKAAyD;IAC3D;;ACxFJ;IDyFI;CCzFJ;;AD4FE;IACE,eAAe;IACf,sDAAsD;IACtD,6EAAwD;IACxD,8BAA8B;IAC9B,uCAAuC;IACvC,UAAU;EACZ;;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,OAAO;IACP,YAAY;IACZ,UAAU;IACV,cAAc;IACd,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;EAChC;;AAGE;MACE,mBAAmB;IACrB;;AAIJ;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":["$font-weight: 400;\n$background-color: var(--card-bg-color);\n$border-color: #efefef;\n$text-color: #333;\n$handle-color: rgba(0, 0, 0, 0.25);\n$box-shadow-border: 0 0 0 calc(1px / var(--scale-x, 1)) rgba(63, 63, 68, 0.05);\n$box-shadow-common: 0 1px calc(3px / var(--scale-x, 1)) 0 rgba(34, 33, 81, 0.15);\n$box-shadow: $box-shadow-border, $box-shadow-common;\n$focused-outline-color: #4c9ffe;\n\n@keyframes pop {\n  0% {\n    transform: scale(1);\n    box-shadow: var(--box-shadow);\n  }\n  100% {\n    transform: scale(var(--scale));\n    box-shadow: var(--box-shadow-picked-up);\n  }\n}\n\n@keyframes fadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.Wrapper {\n  display: flex;\n  box-sizing: border-box;\n  transform: translate3d(var(--translate-x, 0), var(--translate-y, 0), 0)\n    scaleX(var(--scale-x, 1)) scaleY(var(--scale-y, 1));\n  transform-origin: 0 0;\n  touch-action: manipulation;\n\n  &.fadeIn {\n    animation: fadeIn 500ms ease;\n  }\n\n  &.dragOverlay {\n    --scale: 1.05;\n    --box-shadow: $box-shadow;\n    --box-shadow-picked-up: $box-shadow-border,\n      -1px 0 15px 0 rgba(34, 33, 81, 0.01),\n      0px 15px 15px 0 rgba(34, 33, 81, 0.25);\n    z-index: 999;\n  }\n}\n\n.Item {\n  position: relative;\n  display: flex;\n  flex-grow: 1;\n  /* box-shadow: $box-shadow; */\n  background-color: $background-color;\n  -webkit-tap-highlight-color: transparent;\n\n  /* white-space: nowrap; */\n\n  transform: scale(var(--scale, 1));\n  transition: box-shadow 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);\n\n  &:focus-visible {\n    box-shadow: 0 0px 4px 1px $focused-outline-color, $box-shadow;\n  }\n\n  &:not(.withHandle) {\n    touch-action: manipulation;\n    cursor: grab;\n  }\n\n  &.dragging:not(.dragOverlay) {\n    opacity: var(--dragging-opacity, 0.5);\n    z-index: 0;\n\n    &:focus {\n      box-shadow: $box-shadow;\n    }\n  }\n\n  &.disabled {\n    color: #999;\n    background-color: #f1f1f1;\n    &:focus {\n      box-shadow: 0 0px 4px 1px rgba(0, 0, 0, 0.1), $box-shadow;\n    }\n    cursor: not-allowed;\n  }\n\n  &.dragOverlay {\n    cursor: inherit;\n    /* box-shadow: 0 0px 6px 2px $focused-outline-color; */\n    animation: pop 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22);\n    transform: scale(var(--scale));\n    box-shadow: var(--box-shadow-picked-up);\n    opacity: 1;\n  }\n\n  &.color:before {\n    content: '';\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 0;\n    height: 100%;\n    width: 3px;\n    display: block;\n    border-top-left-radius: 3px;\n    border-bottom-left-radius: 3px;\n    background-color: var(--color);\n  }\n\n  &:hover {\n    .Remove {\n      visibility: visible;\n    }\n  }\n}\n\n.Remove {\n  visibility: hidden;\n}\n\n.Actions {\n  display: flex;\n  align-self: flex-start;\n  margin-top: -12px;\n  margin-left: auto;\n  margin-bottom: -15px;\n  margin-right: -10px;\n}\n",null],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `Item-module__Wrapper___LKtob`,
	"fadeIn": `Item-module__fadeIn___NR8Qu`,
	"dragOverlay": `Item-module__dragOverlay___feLrU`,
	"item": `Item-module__Item___FoLxg`,
	"withHandle": `Item-module__withHandle____pAIQ`,
	"dragging": `Item-module__dragging___QLpIK`,
	"disabled": `Item-module__disabled___DSRgF`,
	"pop": `Item-module__pop___DsGbx`,
	"color": `Item-module__color___HaFGG`,
	"remove": `Item-module__Remove___fvxU9`,
	"actions": `Item-module__Actions___YOB5O`
};
export default ___CSS_LOADER_EXPORT___;
